import React from "react";
import { createRoot } from 'react-dom/client'
import SalesGallery from "./Components/SalesGallery";

const SalesHeroElement = document.getElementById('salesHero');

const root = createRoot(SalesHeroElement);

root.render(<SalesGallery />);